import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getRbv3Station } from 'state/api/hdrainClient';
// import { rebootRbv3Station } from 'state/api/hdrainClient';
// import { useSelector, shallowEqual } from 'react-redux';
// import CONSTANTS from 'utils/constants';

const RBV3 = () => {
  const index = useParams().id;

  // const {
  //   isAdmin,
  // } = useSelector(
  //   (state) => ({
  //     isAdmin: CONSTANTS.IS_USER_ROLE_ADMIN[state.auth.userData.role],
  //     isInstaller: CONSTANTS.IS_USER_ROLE_INSTALLER[state.auth.userData.role],
  //   }),
  //   shallowEqual
  // );

  // IMPORT RBV3 DATA
  const [Rbv3data, setRbv3data] = useState([]);

  useEffect(() => {
    let mounted = true;

    const fetchRbv3Station = async () => {
      try {
        const result = await getRbv3Station(index);
        console.log({ result });
        const resultWithTitles = [
          {
            title: 'Connection Timestamp (UTC)',
            value: `${result.cnx} (${result.cnxDiff})`,
          },
          {
            title: 'Last data Timestamp (UTC)',
            value: `${result.lt} (${result.ltDiff})`,
          },
          { title: 'Battery voltage', value: `${result.vbat} V` },
          { title: 'Current Firmware Version', value: result.crFwVersion },
          { title: 'Previous Firmware Version', value: result.pvFwVersion },
          { title: 'Factory Firmware Version', value: result.ftFwVersion },
          { title: 'Last bad Firmware Version', value: result.lbFwVersion },
        ];
        console.log({ resultWithTitles });
        if (mounted) {
          setRbv3data(resultWithTitles);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchRbv3Station();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <>
      {/* TITRE & BOUTONS */}
      <section className="hero is-hero-bar">
        <div className="hero-body">
          <div className="level">
            {/* TITRE */}
            <div className="level-left">
              <div className="level-item">
                <h1 className="title">Rainbox v3 - {index}</h1>
              </div>
            </div>

            {/* BOUTON REBOOT */}
            {/* { isAdmin ? (
              <div className="level-right">
                <div className="level-item">
                    <button
                        type="button"
                        className="button is-small is-warning"
                        onClick={() => rebootRbv3Station(index)}                            >
                        Reboot
                    </button>
                </div>                     
              </div>
            ):(
              <div></div>
            )}                        */}
          </div>
        </div>
      </section>

      {/* CONTENU */}
      <section className="section is-main-section">
        <div className="columns">
          <div className="column ">
            <div className="block station-profile-block">
              <header className="card-header">
                <h4 className="title is-4">Infos</h4>
              </header>
              <div>
                <br />
                {Rbv3data.map((item) => (
                  <div className="is-flex">
                    <div className="column is-narrow">
                      <h3 className="subtitle">{item.title}</h3>
                    </div>
                    <div className="column">
                      <p> {item.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RBV3;
